"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var baseImage = {
    BASE_IMAGE: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment BaseImage on Image {\n      url\n      type\n    }\n  "], ["\n    fragment BaseImage on Image {\n      url\n      type\n    }\n  "]))),
};
exports.default = baseImage;
var templateObject_1;
